export function serializeEntityRef(entity, labelKey = 'name') {
	if (!entity || entity.id == null) return null;

	const ref = { id: entity.id };
	const label =
		entity[labelKey] ?? entity.name ?? entity.text ?? entity.label ?? null;

	if (label != null && label !== '') {
		ref[labelKey] = label;
	}

	return ref;
}

export function serializeEntityRefs(entities, labelKey = 'name') {
	if (!entities?.length) return null;
	return entities
		.map(entity => serializeEntityRef(entity, labelKey))
		.filter(Boolean);
}

export function resolveEntityRef(ref, labelKey = 'name') {
	if (ref == null) return null;

	if (typeof ref === 'number' || typeof ref === 'string') {
		return { id: Number(ref) };
	}

	if (ref.id == null) return null;

	const resolved = { id: ref.id };
	const label = ref[labelKey] ?? ref.name ?? ref.text ?? ref.label ?? null;

	if (label != null && label !== '') {
		resolved[labelKey] = label;
	}

	return resolved;
}

export function resolveEntityRefs(refs, labelKey = 'name') {
	if (!refs?.length) return null;
	return refs.map(ref => resolveEntityRef(ref, labelKey)).filter(Boolean);
}
